import { render, staticRenderFns } from "./ModalEditCancelRules.vue?vue&type=template&id=6754d433&scoped=true"
import script from "./ModalEditCancelRules.vue?vue&type=script&lang=js"
export * from "./ModalEditCancelRules.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCancelRules.vue?vue&type=style&index=0&id=6754d433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754d433",
  null
  
)

export default component.exports